import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const lineChart: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M16 0v1H0v-12h1V0Zm-1-9.75v3.39c0 .118-.055.196-.156.235q-.142.065-.266-.062l-.953-.938-4.937 4.938a.25.25 0 0 1-.188.078.23.23 0 0 1-.172-.078L6.5-4 3.25-.75l-1.5-1.5 4.578-4.578c.05-.05.11-.078.172-.078a.27.27 0 0 1 .188.078L8.5-5l3.625-3.625-.937-.953q-.128-.124-.063-.266c.04-.101.117-.156.234-.156h3.391q.106 0 .172.078.076.066.078.172m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "16",
  }
};
